// Founder 2026-10-27: ordinary site functionality and analytics are always on.
// Advertising stays off until an explicit opt-in through Advertising preferences.
// A first visit never opens a cookie-choice banner on any SnowClub property.
export const SHOW_ADVERTISING_PROMPT = false;
